module.exports = __webpack_public_path__ + "static/img/chicago.eafe42d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/chicago.jpg
// module id = fHwL
// module chunks = 1